module.exports = __webpack_public_path__ + "static/media/22ESCWA11.9046e2a3.jpg";